import MoveTopButton from "../MoveTopButton";
import pdfIco from '../../../imgs/ico-pdf.png';

const Documentacion = ({ selectedProduct }) => {

    //const { selectedProduct } = props;
    // const { productDetail } = useFundDetailsContext();

    if (selectedProduct && selectedProduct.documentacion) {
    const { documentacion } = selectedProduct;

    const legalDocumentos = documentacion.filter(
        (doc) => (doc.tipoDocumento === "LEGAL" && doc.cdvisual === "S")
    );
    const comercialDocumentos = documentacion.filter(
        (doc) => (doc.tipoDocumento === "COMERCIAL" && doc.cdvisual === "S")
    );

    const baseURLBackend = window._env_.BACKEND_ENDPOINT;
    let https = 'https';


    // console.log("comercialDocs",comercialDocumentos.length)
    // console.log("legalDocs",legalDocumentos.length)

        return (
            <div style={{marginTop: 10}}>
                {
                    ((comercialDocumentos.length === 0 && legalDocumentos.length === 0) ?
                        <div style={{marginTop: 10}}>
                            <div className="alert alert-info mt-3" role="contentinfo">No hay documentacion disponible para este producto</div>
                        </div>
                    :
                        <div>
                            {
                                (legalDocumentos.length > 0 ?
                                    <div>
                                        <h4 className="blueText">Documentación legal</h4>
                                        <div className="button-box" style={{maxWidth: 'inherit', textAlign: 'left', cursor:"auto"}}>
                                            {
                                                legalDocumentos.map((docu, idx) =>
                                                    <div key={idx} className="row" >
                                                        <div className="col-lg-11" style={{fontSize: 16}}>
                                                            {docu.tipodoc }
                                                            {/*docu.tipodoc } - {selectedProduct ? selectedProduct.fundsname : ''*/}
                                                        </div>
                                                        <div className="col-lg-1" style={{fontSize: 30, bottom: 10}}>
                                                        {
                                                            ((docu.urlcompleta).includes(https) === true ?
                                                                <a href={`${docu.urlcompleta}`} download={docu.nombre} target="blank">
                                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="icono pdf"></img>
                                                                </a>
                                                            :
                                                                <a href={baseURLBackend + `${docu.urlcompleta}`} download={docu.nombre} target="blank">
                                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="icono pdf"></img>
                                                                </a>
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                : "")
                            }
                            {
                                (comercialDocumentos.length > 0 ?
                                    <div>
                                        <h4 className="blueText">Documentación Comercial</h4>
                                        <div className="button-box" style={{maxWidth: 'inherit', textAlign: 'left', cursor:"auto"}}>
                                            {
                                                comercialDocumentos
                                                    .filter(docu => docu.txdesdoc !== 'pdfFichaProductoSPB')
                                                    .map((docu, idx) =>
                                                //comercialDocumentos.map((docu, idx) =>
                                                    <div key={idx} className="row" >
                                                        <div className="col-lg-11" style={{fontSize: 16}}>
                                                            {docu.tipodoc}
                                                            {/*docu.tipodoc} - {selectedProduct ? selectedProduct.fundsname : ''*/}
                                                        </div>
                                                        <div className="col-lg-1" style={{fontSize: 30, bottom: 10}}>
                                                        {
                                                            ((docu.urlcompleta).includes(https) === true ?
                                                                <a href={`${docu.urlcompleta}`} download={docu.nombre} target="blank">
                                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="icono pdf"></img>
                                                                </a>
                                                            :
                                                                <a href={baseURLBackend + `${docu.urlcompleta}`} download={docu.nombre} target="blank">
                                                                    <img style={{top: 5, position: 'relative', marginBottom: 10, color: 'red'}} src={pdfIco} alt="icono pdf"></img>
                                                                </a>
                                                            )
                                                        }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                : "")
                            }
                            <MoveTopButton />
                        </div>
                    )
                }
            </div>
        )
    }  else {
        return (
            <div style={{marginTop: 10}}>
                <div className="alert alert-danger mt-3" role="alert">Se ha producido un error, vuelve a intentarlo</div>
            </div>
        )
    }
};

export default Documentacion;